import "./btn-notification.scss";

import { observer } from "mobx-react-lite";

import { ReactComponent as MailYellow } from "@client/components/reusable/SvgIcons/library/mail-yellow.svg";

import SvgIcon from "../reusable/SvgIcons";

interface BtnNotificationPopupProps {
	onClick: () => void;
}

const BtnNotificationPopup = observer(
	({ onClick }: BtnNotificationPopupProps) => {
		return (
			<div className="popup-btn" onClick={onClick}>
				<SvgIcon
					width="20"
					height="20"
					component={MailYellow}
					className="mail-icon-white"
				/>
				<div className="notification-badge">1</div>
			</div>
		);
	}
);

export default BtnNotificationPopup;
